<template>
  <div class="base-input-field">
    <b-form-group :label="label" label-class="form-label" :label-for="id">
      <b-input-group :append="append" :id="id">
        <b-form-input :value="formValue" @input="$emit('change', formValue)" />
      </b-input-group>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "BaseInputField",
  components: {},
  props: {
    label: { type: String, default: "Datum" },
    value: { type: String, default: "" },
    id: { type: String, default: "text-area" },
    append: { type: String, default: undefined },
  },
  data() {
    return {
      formValue: this.value,
    };
  },

  watch: {
    value: function(newVal) {
      this.formValue = newVal;
    },
  },
};
</script>

<style scoped></style>
